import { api, unwrap } from "./axiosConfig";

export interface MfaSetupResponse {
  secret: string;
  otpauth_uri: string;
}

export const mfaService = {
  /** Generates a pending TOTP secret. Does NOT activate MFA. */
  async setup(): Promise<MfaSetupResponse> {
    return unwrap(api.post("/api/v1/auth/mfa/setup"));
  },

  /** Activates MFA after the user confirms a code from their authenticator app. */
  async confirm(code: string): Promise<void> {
    await api.post("/api/v1/auth/mfa/confirm", { code });
  },

  /** Disables MFA (requires a current code). */
  async disable(code: string): Promise<void> {
    await api.post("/api/v1/auth/mfa/disable", { code });
  },

  /** Second factor of login: reads the MFA challenge cookie and emits the session. */
  async verify(code: string): Promise<void> {
    await api.post("/api/v1/auth/mfa/verify", { code });
  },
};
